import gql from 'graphql-tag';
import { roleGQLFields } from './role.fields.js';
export function getRolesGQLQuery(fields) {
    return gql `
    query GetRoles($orderBy: RoleListOrderByEnum, $reverse: Boolean) {
      roles(orderBy: $orderBy, reverse: $reverse) {
        ${roleGQLFields(fields)}
      }
    }
  `;
}
//# sourceMappingURL=roles.gql.js.map